<template>
  <div id="sys-wrapper" >
    <!--begin --- header ---begin  -->
    <div class="h-title-con">
      <div class="h-title">
        <span class="title-text"><span class="title-tip"></span>{{id? '编辑':'新增'}}用户</span>
      </div>
      <div class="h-button-warpper">
        <el-button size="small" @click="save" type="primary"><i  class="iconfont icon-baocun"></i>保存</el-button>
        <el-button size="small" @click="back" type="primary"><i class="iconfont icon-fanhui"></i>取消</el-button>
      </div>
    </div>
    <!--end --- header ---end  -->
    <!--begin --- content ---begin  -->
    <div class="white-bg-radius sys-content w-label" style="padding-top: 20px;padding-left: 20px">
      <!--<el-card class="box-card" style="width: 100%" >-->
        <el-form :model="ruleForm" :rules="rules" ref="form" style="min-height:600px"
                 label-position="right" label-width="180px" class="demo-ruleForm" >
          <h2 class="bt-title">用户信息</h2>
          <el-form-item label="用户账号：" prop="account">
            <el-input v-model="ruleForm.account" placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item label="所属组织：" prop="organizeIdList" class="ww-input-dia">
            <el-input v-model="ruleForm.organizeIdListName" placeholder="请输入所属组织"
             @focus="showDialog()"
            suffix-icon="el-icon-tickets"
            :disabled="isUpdate"
             readonly>
             <i class="el-icon-error" v-if="ruleForm.organizeIdListName" slot="append" @click.stop.prevent="clear()"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="员工编号：" prop="jobNumber">
            <el-input v-model="ruleForm.jobNumber" placeholder="请输入员工编号"></el-input>
          </el-form-item>
          <el-form-item label="员工姓名：" prop="userName">
            <el-input v-model="ruleForm.userName" placeholder="请输入员工姓名"></el-input>
          </el-form-item>
          <el-form-item label="手机号码：" prop="mobile">
            <el-input v-model="ruleForm.mobile" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱：" prop="email">
            <el-input v-model="ruleForm.email" placeholder="请输入电子邮箱"></el-input>
          </el-form-item>
          <el-form-item label="备注：" prop="remark">
            <el-input v-model="ruleForm.remark" placeholder="请输入备注"></el-input>
          </el-form-item>
          <el-form-item label="状态：" prop="status">
            <el-radio-group v-model="ruleForm.status">
              <el-radio v-for=" (item,index) in statusList" :key="index" :label="item.value">{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
           <el-form-item label="用户类型：" prop="accountType">
            <el-select class="area-select"  v-model="ruleForm.accountType" collapse-tags placeholder="请选择用户类型">
              <el-option
                v-for="item in accountTypeData"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <h2 class="bt-title">分配角色</h2>
          <el-form-item label="角色选择：" prop="roleIdList" class="ww-input-dia">
            <!--  type="textarea" autosize-->
            <el-input v-model="ruleForm.roleIdNameList" placeholder="请选择角色"
             @focus="openDialog" suffix-icon="el-icon-tickets" readonly>
               <i  class="el-icon-error"  v-if="ruleForm.roleIdNameList" slot="append" @click.stop.prevent="clear(1)"></i>
            </el-input>
          </el-form-item>
        </el-form>
      <!--</el-card>-->

    </div>
    <checkbox-dialog
      :modal-title="'所属组织'"
      :dialog-visible="showDialogFlag"
      :data="organizationData"
      :defaultCheckedKeys="ruleForm.organizeIdList"
      :default-props="defaultOrganizeProps"
      @confirm-select-item="setSelectItem"
      @cancel="cancel"
    ></checkbox-dialog>
    <tabel-dialog
      ref="role"
      :modal-title="'角色选择'"
      :data="roleList"
      :dialog-visible="showTabelFlag"
      @close="close"
      @confirm-select-item="selectRole" >
      </tabel-dialog>
  </div>

</template>

<script>
  import { mapGetters } from 'vuex';
  import commonMixin from '@/mixins/common.js';
  import checkboxDialog from "../components/checkbox-dialog.vue";
  import tabelDialog from "../components/tabel-role-checkbox.vue";
  import { methodPost, methodGet } from '@/api/requestWithMessage'

  const addUrl = '/user/add'
  const modifyUrl = '/user/edit'
  const getById = '/user/get/'
  export default {
    name: 'AddUserManagemen',
    mixins: [commonMixin],
    components: { checkboxDialog, tabelDialog },
    data() {
      return {
        id: this.$route.query.id,
        isUpdate: false,
        showDialogFlag: false,
        showTabelFlag: false,
        organizationData: [],
        roleList: [],
        statusList: [
          { label: '有效', value: 1 },
          { label: '无效', value: 0 }
        ],
        accountTypeData: [
          { label: '达能集团帐号', value: 1 },
          { label: '系统平台帐号', value: 0 }
        ],
        roleBackIdNames: [], // 回显
        ruleForm: {
          account: '', // 用户账号
          organizeIdListName: '',
          organizeIdList: [], // 所属组织
          jobNumber: '', // 员工编号
          userName: '', // 员工姓名
          mobile: '', // 手机号
          email: '', // 邮箱
          remark: '', // 备注
          status: 1, // 是否启用
          accountType: '',
          roleIdList: [], // 角色选择
          roleIdNameList: ''// 角色选择

        },
        rules: {
          account: [ // 用户账号
            { required: true, message: '此项为必填项', trigger: 'blur' },
            { pattern: /.{4,20}$/, min: 4, max: 20, message: '长度为 4 到 20 个数字或字母', trigger: 'change' }
          ],
          organizeIdList: [
            { required: true, message: '此项为必填项', trigger: 'blur' }

          ],
          jobNumber: [
            { required: true, message: '此项为必填项', trigger: 'blur' },
            { pattern: /.{4,20}$/, min: 4, max: 20, message: '长度为 4 到 20 个数字或字母', trigger: 'change' }
          ],
          userName: [
            { required: true, message: '此项为必填项', trigger: 'blur' }
          ],
          mobile: [
            { type: 'string', pattern: /^1[3456789]\d{9}$/, message: '请输入手机号', maxlength: 11 }
          ],
          email: [
            { type: 'email', message: '请输入邮箱地址' }
          ],
          status: [
            { required: true, message: '此项为必填项', trigger: 'blur' }
          ],
          accountType: [
            { required: true, message: '此项为必填项', trigger: 'change' }
          ],
          roleIdList: [
            { required: true, message: '此项为必填项', trigger: 'blur' }
          ]

        },
        defaultOrganizeProps: {
          children: 'children',
          label: 'label'
        },
        defaultProps: {
          children: 'children',
          label: 'label',
          searchName: ["name", "code"]
        }
      }
    },
    methods: {
      back(isRefresh = true) {
        const path = '/userManagementList/index'
        this.goBack(path)
        if (isRefresh) {
          this.$nextTick(() => {
            this.$eventBus.$emit('refresh-custom-table')
          })
        }
      },
      getOrigaztion() {
        methodPost('/sysOrganize/getSysOrganizeTree').then(res => {
          this.organizationData = res.data
        })
      },
      getRoles() {
        methodPost('/role/simplelist').then(res => {
          this.roleList = res.data
        })
      },
      save() {
        this.$refs.form.validate(valid => {
          console.log(valid)
          if (valid) {
            this.submitForm()
          } else {
            console.log('error submit!!')
          }
        })
      },
      submitForm() {
        const param = this.ruleForm
        const url = this.id ? modifyUrl : addUrl;
        if (this.id) {
          param['id'] = this.id
        }
        methodPost(url, param).then(res => {
          console.log(res)
          if (res.code === 0) {
            this.back(true)
          } else {
            this.$message.error(res.message || '出错了！')
          }
        }).catch(err => {
          console.error(err)
          this.$message.error(err.message || '出错了！')
        })
      },
      clear(val) {
        if (val === 1) {
          this.ruleForm.roleIdList = [];
          this.ruleForm.roleIdNameList = '';
          this.roleBackIdNames = []
        } else {
          this.ruleForm.organizeIdList = [];
          this.ruleForm.organizeIdListName = '';
        }
      },
      init() {
        this.getOrigaztion();
        this.getRoles()
        if (this.id) {
          methodGet(getById + `${this.id}`).then(res => {
            const data = res.data
            const orNames = []
            const orIds = []
            const roleIds = []
            const roleNames = []
            const roleIDNames = []
            if (data.organizeList && data.organizeList.length > 0) {
              data.organizeList.forEach((item) => {
                orIds.push(item.id)
                orNames.push(item.organizeName)
              })
            }
            if (data.roleList && data.roleList.length > 0) {
              data.roleList.forEach((item) => {
                roleIDNames.push({ id: item.id, roleName: item.roleName })
                roleIds.push(item.id)
                roleNames.push(item.roleName)
              })
            }
            this.roleBackIdNames = roleIDNames
            this.ruleForm = {
              roleIdList: roleIds,
              roleIdNameList: roleNames.toString(),
              organizeIdList: orIds,
              organizeIdListName: orNames.toString(),
              account: data.account,
              jobNumber: data.jobNumber,
              mobile: data.mobile, // 手机号
              remark: data.remark,
              email: data.email,
              parentName: data.parentMenuName,
              status: data.status,
              accountType: data.accountType,
              userName: data.userName
            }
          })
        }
      },
      // 关闭弹框
      cancel() {
        this.showDialogFlag = false;
      },
      close() {
        this.showTabelFlag = false;
      },
      selectRole(val) {
        this.close()
        const keys = []
        const names = []
        const idNames = []

        if (Array.isArray(val)) {
          val.forEach(function(item) {
            idNames.push({ id: item.id, roleName: item.roleName })
            keys.push(item.id)
            names.push(item.roleName)
          })
        }
        this.roleBackIdNames = idNames
        this.ruleForm.roleIdNameList = names.toString()
        if (this.ruleForm.roleIdNameList) {
          this.$refs.form.clearValidate('roleIdList')
        }
        this.ruleForm.roleIdList = keys
      },
      // 出现弹框里边的方法
      setSelectItem(val) {
        this.showDialogFlag = false;
        const keys = []
        const names = []
        if (Array.isArray(val)) {
          val.forEach(function(item) {
            keys.push(item.id)
            names.push(item.label)
          })
        }
        this.ruleForm.organizeIdListName = names.toString()
        this.ruleForm.organizeIdList = keys
        if (this.ruleForm.organizeIdListName) {
          this.$refs.form.clearValidate('organizeIdList')
        }
      }, // 显示弹框
      showDialog(e, val) {
        this.showDialogFlag = true;
      },
      openDialog() {
        this.showTabelFlag = true;
        this.$refs['role'].open({
          url: '/role/simplelist',
          dlgTitle: '角色选择',
          initCheckboxVal: this.roleBackIdNames,
          hasPage: false,
          searchFieldName: 'roleName',
          emptyMessage: '暂无数据',
          tableColumns: [
            { name: 'roleCode', label: '系统角色代号' },
            { name: 'roleName', label: '角色名称' }
          ]
        });
      }
    },
    computed: {
      ...mapGetters([
        'sidebar'
      ]),
      disabled() {
        return !!this.id
      }
    },
    mounted() {
    },
    created() {
      this.init()
    }
  }
</script>

<style lang="scss">
  #sys-wrapper {
    position: relative;
    .sys-content {
      .bt-title{
        border-bottom:1px solid #eee;
        height:30px;
        font-size:14px;
        color:#333;
        margin-bottom:20px;
      }
      .el-form-item__label {
        padding-right: 5px !important;
      }
      .el-form-item__error{
        left: 105%;
        width: 200px;
        top: 25%;
      }
      .el-form-item{
        margin-bottom: 10px;
      }

    }
    .sys-footer{
      position: absolute;
      bottom: 0px;
      left: 0px;
      margin-left: 20px;
      height: 60px;
      width: 100%;
    }
    .content-params {
      padding:5px 20px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      overflow: hidden;
      .params {
        min-width:340px;
        margin: 5px 0;
        font-size: 0;
      }
      .custom_label {
        min-width: 80px;
        display:inline-block;
        font-size: 14px;
        font-weight:700;
        text-align: right;
        color:#606266;
        i {
          color: red;
          font-style: normal;
          vertical-align: middle;
        }
      }
    }
}

</style>
<style>
#app .el-card.box-card.is-always-shadow{
  -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,0);
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0);
}
#app .el-card.box-card{
  border:0;
  border-radius:0;
}
#app .el-input--mini .el-input__inner {
    height: 22px;
    line-height: 22px;
}
.params .el-input{
    width:210px!important;
  }
</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/userManagementList/add.vue